import { render, staticRenderFns } from "./DeleteKeyHandler.vue?vue&type=template&id=247e297d&"
import script from "./DeleteKeyHandler.vue?vue&type=script&lang=ts&"
export * from "./DeleteKeyHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports